import * as React from 'react';
import { Pagination } from '../Pagination';
import { jsx as _jsx } from "react/jsx-runtime";
/** Отступ для учета заголовка страницы **/
var SCROLL_OFFSET = 150;
export function PaginationContainer(_ref) {
  var onPageSelect = _ref.onPageSelect,
    page = _ref.page,
    lastPage = _ref.lastPage,
    cardsRef = _ref.cardsRef;
  var handleClickPagination = React.useCallback(function (page) {
    if (cardsRef.current) {
      var targetPosition = cardsRef.current.offsetTop;
      var offsetPosition = targetPosition - SCROLL_OFFSET;
      window.requestAnimationFrame(function () {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    }
    onPageSelect(page);
  }, [onPageSelect, cardsRef]);
  if (lastPage < 2) {
    return null;
  }
  return /*#__PURE__*/_jsx(Pagination, {
    currentPage: page,
    lastPage: lastPage,
    onClick: handleClickPagination
  });
}